import { z } from 'zod';

import { Acquirer } from 'data/merchant/models/acquirer';

export const DepositStatus = z.enum([
  'CREATED',
  'MONEY_RECEIVED',
  'PAID',
  'EXPIRED',
  'DISPUTED',
  'CANCELLED',
]);
export type DepositStatus = z.infer<typeof DepositStatus>;

export const DepositCredentialsType = z.enum(['CARD', 'SBP']);
export type DepositCredentialsType = z.infer<typeof DepositCredentialsType>;

export const DepositCredentials = z.object({
  type: DepositCredentialsType,
  value: z.string(),
  bank: z.string(),
  name: z.string().optional(),
});
export type DepositCredentials = z.infer<typeof DepositCredentials>;

export const DepositMethod = z.enum(['SBP', 'SBP_100', 'CARD', 'SBER_AZN']);
export type DepositMethod = z.infer<typeof DepositMethod>;

export const isSbpMethod = (method: DepositMethod) =>
  ['SBP', 'SBP_100'].includes(method);

export const Deposit = z.object({
  paymentLink: z.string().nullish(),
  acquirer: Acquirer,
  method: DepositMethod.nullable(),
  credentials: DepositCredentials.nullish(),
  amount: z.string().nullable(),
  currency: z.string(),
  expiryDate: z.coerce.date(),
  successRedirect: z.string().nullable(),
  failureRedirect: z.string().nullable(),
  customerId: z.string().nullish(),
  status: DepositStatus,
});
export type Deposit = z.infer<typeof Deposit>;
